import React, {useCallback,useState,useRef} from 'react';
import styles from './LogoSprite.module.scss'
import panelStyles from "components/homePanels/Panels.module.scss";
import {useSelector} from "react-redux";

const LogoSprite = (props) => {

    const windowData = useSelector(state => state.window);
    const [bgStyle, setBgStyle] = useState({});
    const sprite = useRef();

    const animate = useCallback((node) => {
        if(!node) return;
        sprite.current = node;

        let width = props.size;
        let newWidth;
        if(windowData.width < 500){
            newWidth = windowData.width * .6
        } else if(windowData.width > 500 && windowData.height < 700){
            newWidth = windowData.height * .4
        } else {
            newWidth = width * .8
        }

        node.style.height = `${newWidth}px`;
        node.style.width = `${newWidth}px`;

    },[windowData,props.size])

    function applyStyle(){

        let style = {
            backgroundImage: `url(${props.sprite})`,
            animationTimingFunction: `steps(${props.steps})`,
            animationDelay: `${props.delay}s`,
            animationDuration: `${props.duration}s`,
        };

        setBgStyle(style);
        sprite.current.classList.add(styles.logo)


    }

    return (
        <>
            <div className={`${panelStyles.logo} ${props.className}`} style={bgStyle} ref={animate}/>
            <img src={props.sprite} alt={''} style={{display:'none'}} onLoad={applyStyle}/>
        </>
    )
};

export default LogoSprite
